module.exports = __webpack_public_path__ + "img/stress_estimate2.0af54cc4.png";